"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var disclaimers_1 = require("../models/disclaimers");
var GlobalDisclaimerStore = /** @class */ (function () {
    function GlobalDisclaimerStore() {
        this.lastSuperscript = 0;
        this.values = [];
        this.subscribers = [];
    }
    GlobalDisclaimerStore.prototype.subscribe = function (subscriber) {
        if (!this.subscribers) {
            this.subscribers = [];
        }
        this.subscribers.push(subscriber);
    };
    GlobalDisclaimerStore.prototype.publish = function () {
        if (this.subscribers && this.subscribers.length > 0) {
            this.subscribers.forEach(function (subscriber) {
                if (subscriber && typeof subscriber === 'function') {
                    subscriber();
                }
            });
        }
    };
    GlobalDisclaimerStore.prototype.add = function (appKey, responseContext, queryStore) {
        var optionsParams = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            optionsParams[_i - 3] = arguments[_i];
        }
        var response = new Set();
        if (!this.values) {
            this.values = [];
        }
        var hasChange = false;
        var overrideDefined = optionsParams.some(function (option) { return option.overrideOptions; });
        if (overrideDefined) {
            // Get the override options to the end of the options
            // Since it is not specified in the requirements we will have the overridden superscripts at the end
            // We can enable a config option in the overrideOptions to set the position
            optionsParams = this.sortOptionsParams(optionsParams);
        }
        var _loop_1 = function (options) {
            // Add text logic in here too
            var disclaimerType = options.disclaimerType, _a = options.textQuery, textQuery = _a === void 0 ? {} : _a;
            if (textQuery) {
                var text = disclaimers_1.GlobalDisclaimerStoreValue.getText(queryStore, disclaimerType, textQuery, responseContext);
                // SETUP NEW COMPOSITE KEY WITH TYPE AND TEXT
                if (text && text.length > 0) {
                    var compositeKey_1 = disclaimerType + "_" + text;
                    var existing = this_1.values.find(function (value) { return value.key === compositeKey_1; });
                    if (existing) {
                        existing.addApp(appKey, options);
                        response.add(existing);
                    }
                    else {
                        var nextSuperscript = options.overrideOptions ? options.overrideOptions.character : ++this_1.lastSuperscript;
                        var value = new disclaimers_1.GlobalDisclaimerStoreValue(queryStore, nextSuperscript, compositeKey_1, responseContext, appKey, options);
                        this_1.values.push(value);
                        response.add(value);
                    }
                    if (this_1.values.length > 0) {
                        hasChange = true;
                    }
                }
            }
        };
        var this_1 = this;
        for (var _a = 0, optionsParams_1 = optionsParams; _a < optionsParams_1.length; _a++) {
            var options = optionsParams_1[_a];
            _loop_1(options);
        }
        // Order here is important otherwise the reorder would not fire
        hasChange = this.reorder() || hasChange;
        if (hasChange) {
            this.publish();
        }
        return Array.from(response);
    };
    GlobalDisclaimerStore.prototype.sortOptionsParams = function (optionsParams) {
        return optionsParams.sort(function (a, b) {
            // Sort the overridden options to the front
            return (!a.overrideOptions && b.overrideOptions) ? -1 : (a.overrideOptions && !b.overrideOptions) ? 1 : 0;
        });
    };
    GlobalDisclaimerStore.prototype.get = function (level, appKey) {
        return this.values.filter(function (value) { return value.matches(level, appKey); }).sort(function (a, b) {
            if (typeof a.superscript === 'number' && typeof b.superscript === 'number') {
                return a.superscript - b.superscript;
            }
            if (typeof a.superscript === 'number') {
                return -1;
            }
            if (typeof b.superscript === 'number') {
                return 1;
            }
            return 0;
        });
    };
    GlobalDisclaimerStore.prototype.clear = function () {
        this.values = [];
        this.publish();
    };
    GlobalDisclaimerStore.prototype.reorder = function () {
        var hasChange = false;
        var ordersDefined = this.values.some(function (v) { return v.order !== disclaimers_1.GlobalDisclaimerStoreValue.maxOrder; });
        if (ordersDefined) {
            var currentOrder = this.values.map(function (v) { return v.superscript; });
            this.values = this.values.sort(function (a, b) {
                if (a.order === b.order) {
                    return (a.superscript < b.superscript) ? -1 : (a.superscript > b.superscript) ? 1 : 0;
                }
                return (a.order < b.order) ? -1 : 1;
            });
            var newOrder = this.values.map(function (v) { return v.superscript; });
            for (var i = 0; i < currentOrder.length; i++) {
                var oldValue = currentOrder[i];
                var newValue = newOrder[i];
                if (oldValue !== newValue) {
                    hasChange = true;
                    break;
                }
            }
            if (hasChange) {
                var lastSuperscript_1 = 0;
                this.values.forEach(function (value) {
                    if (typeof value.superscript === 'number') {
                        value.superscript = ++lastSuperscript_1;
                    }
                });
            }
        }
        return hasChange;
    };
    return GlobalDisclaimerStore;
}());
exports.GlobalDisclaimerStore = GlobalDisclaimerStore;
//# sourceMappingURL=GlobalDisclaimerStore.js.map